import { render, staticRenderFns } from "./BookingAccommodationTypes.vue?vue&type=template&id=89f160e6"
import script from "./BookingAccommodationTypes.js?vue&type=script&lang=js&external"
export * from "./BookingAccommodationTypes.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports